import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewAnimal extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('animal'),
        };
    }

    createAnimal = async () => {
        const { callback = () => {} } = this.props;
        const { animalStore } = this.props.stores;
        const { newAnimal } = animalStore;
        const response = await animalStore.adminCreate(newAnimal);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, isNew } = this.props;
        const { animalStore } = this.props.stores;
        if (!isNew) {
            animalStore.adminSetFromIdx(idx);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, animalStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newAnimal, animal } = animalStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <Versions stores={this.props.stores} type='animal' id={animal.id} key={`admin-animal-${animal.id}`} />

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='animal.new'>New animal</Text> : <Text id='animal.edit'>Edit animal</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={animalStore} objectName={isNew ? 'newAnimal' : 'animal'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start pt-3'>
                        <h5>dyreIdRequest</h5>
                        <xmp>{JSON.stringify(animal.dyreIdRequest, null, 4)}</xmp>
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start pt-3'>
                        <h5>dyreIdRespone</h5>
                        <xmp>{JSON.stringify(animal.dyreIdRespone, null, 4)}</xmp>
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createAnimal}>
                            {isNew ? <Text id='animal.create'>Create animal</Text> : <Text id='animal.save'>Save animal</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewAnimal;
